"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PastOrders = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _formatters = require("formatters");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _Orders = babelHelpers.interopRequireDefault(require("Orders"));

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _class, _descriptor, _temp, _class3, _descriptor2, _temp2;

var PastOrdersPage = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(PastOrdersPage, _Component2);

  function PastOrdersPage() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, PastOrdersPage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(PastOrdersPage)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(PastOrdersPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement(PastOrders, this.content));
    }
  }]);
  return PastOrdersPage;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = PastOrdersPage;
var PastOrders = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PastOrders, _Component);

  function PastOrders() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PastOrders);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PastOrders)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "orderList", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PastOrders, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "block stack header-block height-60vh",
        "data-block-type": "header",
        "data-block-id": "pastOrderHeader"
      }, _react.default.createElement("div", {
        className: "spotlight-header variable-background",
        style: _base.default.styleForBackgroundObject({
          landscape: '/images/prositebgdefault1400x900.jpg',
          portrait: '/images/prositebgdefault1400x900.jpg',
          imageOverlay: 'none'
        })
      }, _react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, _react.default.createElement("h1", null, "Past Orders"), _react.default.createElement("h2", null, "Need help? 503-906-8148 for assistance.")))), _react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "pastOrders"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, _react.default.createElement(_Orders.default, {
        orderList: this.orderList
      }))));
    }
  }]);
  return PastOrders;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "orderList", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.PastOrders = PastOrders;